import { SortingType } from 'constants/index';

import { WorkorderField } from './types';

export const DEFAULT_SORT = {
    field: WorkorderField.INSPECTION_DATE,
    type: SortingType.DESC,
};
